// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-wrap__ArtPieces_RpyUO {\n  overflow-y: scroll;\n  padding-bottom: 40px;\n}\n.filters__ArtPieces_YZBfC {\n  position: relative;\n}\n.filters__ArtPieces_YZBfC form {\n  display: flex;\n}\n", ""]);
// Exports
exports.locals = {
	"grid-wrap": "grid-wrap__ArtPieces_RpyUO",
	"gridWrap": "grid-wrap__ArtPieces_RpyUO",
	"filters": "filters__ArtPieces_YZBfC"
};
module.exports = exports;
